import ImagePicker from "../picker/ImagePicker";
import CommonStyleEditor from "./CommonStyleEditor";

export default function ImageCellProperties({ cell, onChange }) {
    return (
        <div className="property-section">
            <div className="property-section-title">Image</div>
            <div className="property-row">
                <ImagePicker value={cell.image_uri} onChange={(image) => onChange(cell.cell_id, {image_uri: image, type: cell.type})}/>
            </div>
            <div className="property-section-title">Resize Mode</div>
            <div className="property-row">
                <select className="property-input property-input-small" value={cell.resize_mode || 'contain'} onChange={(e) => onChange(cell.cell_id, {...cell, styles_properties: {...cell.styles_properties, objectFit: e.target.value}, type: cell.type})}>
                    <option value="none">Aucun</option>
                    <option value="cover">Couvrir</option>
                    <option value="contain">Contenir</option>
                    <option value="fill">Remplir</option>
                </select>
            </div>
            <CommonStyleEditor cell={cell} onChange={onChange}/>
        </div>
    );
}